<template>
  <SFLink
    :to="
      isBrandListing
        ? buildSingleBrandPath(category)
        : buildCategoryPath(category)
    "
    raw
    class="flex h-10 w-fit flex-nowrap items-center justify-center whitespace-pre rounded-[2.375rem] bg-gray-100 px-4 text-base font-medium text-gray-600 focus-visible:outline-offset-[-1px]"
    :class="{
      'border-2 border-gray-900 bg-white font-semibold text-gray-900': isActive,
    }"
  >
    {{ category.name }}
  </SFLink>
</template>

<script setup lang="ts">
import type { Category } from '@scayle/storefront-nuxt'
import { useRouteHelpers } from '~/composables'
import { SFLink } from '#storefront-ui/components'

const { buildCategoryPath, buildSingleBrandPath } = useRouteHelpers()

defineProps<{
  category: Category
  isActive: boolean
  isBrandListing?: boolean
}>()
</script>
